import { onboardingRegistrationAccessHelper } from 'legacy/lut/classes/helpers/OnboardingRegistrationAccessHelper'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { registrationLoginViaToken } from 'onboarding/classes/helpers/registration/registrationLoginViaToken'

interface IRegistrationLoginArgs {
  token: string
  requestId: number
  email: string
  requestType?: RequestTypes
}

interface IRegistrationLoginRes {
  allowRedirect?: boolean
  redirectRequestId?: number | null
  warningMessage?: string
  requestWasRejected?: boolean
}
export const registrationLogin = async ({
  token,
  requestId,
  email,
  requestType,
}: IRegistrationLoginArgs): Promise<IRegistrationLoginRes> => {
  if (token) {
    return registrationLoginViaToken({ token, requestId })
  }

  const { warningMessage, redirectRid, requestWasRejected } =
    await onboardingRegistrationAccessHelper.checkEmailAccessToEditRegistration(email, requestType)

  if (warningMessage) {
    return { warningMessage, requestWasRejected }
  }
  return { redirectRequestId: redirectRid, allowRedirect: !!redirectRid }
}
